"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var api = _interopRequireWildcard(require("@/api/notice.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Dict',
  dicts: [],
  components: {},
  data: function data() {
    return {
      isLoading: false,
      visible: false,
      tinymceRenderFlag: true,
      tinymceKey: 0,
      dataForm: {
        content: '',
        status: ''
      },
      standardRangeConfig: {},
      dataRule: {
        content: [
          // 公告内容 为非必填项
        ],
        status: [
          // 状态 为非必填项
        ]
      },
      multiSelectFields: [],
      singleSelectFields: [],
      switchFields: [],
      tinymceFields: []
    };
  },
  methods: {
    resetTinymceFields: function resetTinymceFields() {
      var _this = this;
      this.tinymceFields.forEach(function (field) {
        _this.dataForm[field] = '';
        _this.$forceUpdate();
      });
      this.tinymceKey += 1;
    },
    handleDialogClose: function handleDialogClose() {
      this.tinymceRenderFlag = false;
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate();
      }
      // 清空标准范围临时变量
      for (var tempVarName in this.standardRangeConfig) {
        this[tempVarName] = null;
      }
    },
    transformMultiSelectToArr: function transformMultiSelectToArr(formData) {
      this.multiSelectFields.forEach(function (field) {
        if (formData[field] && typeof formData[field] === 'string') {
          formData[field] = formData[field].split(',').filter(function (item) {
            return item.trim();
          });
        } else if (!formData[field]) {
          formData[field] = [];
        }
      });
      return formData;
    },
    transformSingleSelectToStr: function transformSingleSelectToStr(formData) {
      this.singleSelectFields.forEach(function (field) {
        if (formData[field] !== undefined && formData[field] !== null) {
          formData[field] = String(formData[field]);
        } else {
          formData[field] = '';
        }
      });
      return formData;
    },
    transformSwitchToStr: function transformSwitchToStr(formData) {
      this.switchFields.forEach(function (field) {
        if (formData[field] !== undefined && formData[field] !== null) {
          formData[field] = String(formData[field]);
        } else {
          formData[field] = '0';
        }
      });
      return formData;
    },
    transformMultiSelectToStr: function transformMultiSelectToStr(formData) {
      var submitData = _objectSpread({}, formData);
      this.multiSelectFields.forEach(function (field) {
        if (Array.isArray(submitData[field])) {
          submitData[field] = submitData[field].join(',');
        }
      });
      return submitData;
    },
    init: function init(id) {
      var _this2 = this;
      this.tinymceRenderFlag = true;
      this.isLoading = false;
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(function () {
        _this2.$refs['dataForm'].resetFields();

        // 初始化标准范围临时变量
        for (var tempVarName in _this2.standardRangeConfig) {
          _this2[tempVarName] = null;
        }
        if (_this2.dataForm.id === 0) {
          _this2.tinymceFields.forEach(function (field) {
            _this2.dataForm[field] = '';
          });
          _this2.tinymceKey += 1;
        } else {
          api.noticeDetailApi(id).then(function (res) {
            res = _this2.transformSwitchToStr(res);
            res = _this2.transformSingleSelectToStr(res);
            _this2.dataForm = _this2.transformMultiSelectToArr(res);
            _this2.tinymceKey += 1;
            // 初始化标准范围临时变量值
            _this2.initStandardRangeTempVars();
          });
        }
      });
    },
    dataSubmit: function dataSubmit() {
      var _this3 = this;
      if (this.isLoading) {
        console.log('loading...');
        return;
      }
      this.isLoading = true;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var submitData = _this3.transformMultiSelectToStr(_this3.dataForm);
          if (_this3.dataForm.id) {
            api.noticeUpdateApi(submitData).then(function (res) {
              _this3.visible = false;
              _this3.$message.success('修改成功!');
              _this3.$emit('refreshDataList');
            }).catch(function (e) {
              _this3.isLoading = false;
            });
          } else {
            api.noticeCreateApi(submitData).then(function (res) {
              _this3.visible = false;
              _this3.$message.success('添加成功!');
              _this3.$emit('refreshDataList');
            }).catch(function (e) {
              _this3.isLoading = false;
            });
          }
        } else {
          _this3.isLoading = false;
        }
      });
    },
    // 引入范围相关方法
    handleStandardRangeChange: function handleStandardRangeChange(startField, endField, value) {
      if (Array.isArray(value) && value.length === 2) {
        this.dataForm[startField] = value[0];
        this.dataForm[endField] = value[1];
      } else {
        this.dataForm[startField] = null;
        this.dataForm[endField] = null;
      }
    },
    initStandardRangeTempVars: function initStandardRangeTempVars() {
      for (var tempVarName in this.standardRangeConfig) {
        var config = this.standardRangeConfig[tempVarName];
        var startField = config.startField;
        var endField = config.endField;
        var startValue = this.dataForm[startField];
        var endValue = this.dataForm[endField];
        if (startValue && endValue) {
          this[tempVarName] = [startValue, endValue];
        } else {
          this[tempVarName] = null;
        }
      }
    }
  }
};